<template>
  <div>
    <div>
      {{ offer.established_date && $moment(offer.established_date).format('DD/MM/YYYY') }}
    </div>

    <!-- RTL Checklist -->
    <div class="checklist-container my-4">
      <div class="checklist-item" v-for="(item, index) in checklistItems" :key="index">
        <label class="checkbox-label">
          <input
            type="checkbox"
            v-model="item.checked"
            @change="updateChecklist"
          />
          <span class="checkbox-text">{{ item.text }}</span>
          <button
            v-if="item.hasLink"
            @click="openEvaluationModal"
            class="button is-text is-small evaluation-link"
          >
            [לינק ל-evaluation modal]
          </button>
        </label>
      </div>
    </div>

    <p><span class="has-text-weight-bold">Offer message:</span> {{ offerMessage }}</p>

    <div class="is-flex my-4 is-justify-content-space-around">
      <router-link
        :to="{
          name: 'applicant-offers',
          query: {
            statuses: 'awaiting_company,system_strong,awaiting_applicant_strong,awaiting_admin_intake',
            applicant_id: payload.resources.applicant.resource_id,
            m: 1,
            sort: $settings.get({ path: 'pages.applicantOffers.defaultSorters' }),
            is_hot_positions: 'true'
          }
        }"
        class="button is-info is-outlined">
          Offers
        </router-link>
      <img @click="relatedPositions" src="/magic_wand.png" width="40" alt="reject offer icon" class="operation_icon" />
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import OffersHelper from '@/custom/classes/offers_helper.js'

export default {
  name: 'position-offers-report',
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {
      offers_helper: new OffersHelper(),
      offer: {},
      checklistItems: [
        { text: 'בחנתי את האופר של המועמד', checked: false, hasLink: false },
        { text: 'בחנתי אופרים נוספים שרלוונטיים למועמד', checked: false, hasLink: false },
        { text: 'יש אישור הגשה חופשית + שיחה מהשבוע האחרון - הגשתי בהתאם לשק"ד', checked: false, hasLink: false },
        { text: 'שוחחתי טלפונית עם מועמד', checked: false, hasLink: false },
        { text: 'פולאפ תהליכים ומשרות מול המועמד', checked: false, hasLink: false },
        { text: 'סיימתי הגשות חדשות והקפצות של המועמד', checked: false, hasLink: false }
      ]
    }
  },
  computed: {
    offerMessage () {
      if (!this.offer.message) return ''
      const r = new RegExp('.+(?=<messsage-meta>)', 's')
      return this.offer.message.match(r)[0]
    }
  },
  created () {
    this.$network_utils
      .getOfferBy({
        applicant_id: this.payload.resources.applicant.resource_id,
        position_id: this.payload.resources.position.id
      })
      .then(response => {
        this.offer = response[0]
        this.loadChecklist()
      })
  },
  methods: {
    updateChecklist () {
      // Store checklist state in localStorage for persistence
      const key = `checklist_offer_${this.offer.id}`
      localStorage.setItem(key, JSON.stringify(this.checklistItems))
    },
    loadChecklist () {
      // Load checklist state from localStorage
      const key = `checklist_offer_${this.offer.id}`
      const saved = localStorage.getItem(key)
      if (saved) {
        try {
          const savedItems = JSON.parse(saved)
          this.checklistItems.forEach((item, index) => {
            if (savedItems[index]) {
              item.checked = savedItems[index].checked
            }
          })
        } catch (e) {
          console.error('Error loading checklist:', e)
        }
      }
    },
    openEvaluationModal () {
      this.create({
        designator: 'evaluation-modal',
        component_name: 'EvaluationModal',
        modal_title: 'הערכת מועמד',
        props: {
          applicant: this.payload.resources.applicant,
          offer: this.offer
        }
      })
    },
    rejectOffer () {
      this.offers_helper.rejectOffer(this.offer)
    },
    relatedPositions () {
      const data = this.payload.resources
      this.create({
        designator: 'related-positions-modal',
        component_name: 'RelatedPositions',
        position: data.position,
        applicant: data.applicant,
        modal_title: data.position.title + ' - ' + data.position.company.name + ' - Related Positions '
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>

<style scoped>
.checklist-container {
  direction: rtl;
  text-align: right;
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.checklist-item {
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
}

.checklist-item:last-child {
  margin-bottom: 0;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  width: 100%;
  flex-direction: row-reverse;
  justify-content: flex-end;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  flex-shrink: 0;
  margin: 0;
}

.checkbox-text {
  flex: 1;
  line-height: 1.5;
  color: #2c3e50;
  text-align: right;
}

.evaluation-link {
  padding: 2px 8px;
  text-decoration: none;
  color: #3273dc;
  font-size: 0.85rem;
  margin-right: 8px;
}

.evaluation-link:hover {
  text-decoration: underline;
  background: transparent;
}
</style>
